export const DASHBOARD_STATUS = {
  VIEW: 0,
  EDIT: 1
};
export const CHART_TYPE = {
  NPS: 1,
  CES: 2,
  CSAT: 3,
  INTERACTIONS: 4,
  COLUMN: 5,
  SURVEY_OPINIONS: 6,
  PERFORMANCE_DATA: 7,
  PERFORMANCE_FUNNEL: 8,
  CUSTOMER_FEELINGS: 9,
  EVOLUTION: 10,
  SURVEY_DIGEST: 11, // TODO chart
  CES2: 12,
  CESINDEX: 13,
  DISTRIBUTION: 14,
  WORDS_CLOUD: 15,
  PERFORMANCE_FUNNEL_WIDGET: 16,
  CATEGORIES: 17,
  MULTIPLECHOICE: 18
};
export const PERIOD = {
  DAILY30: 1,
  DAILY7: 2,
  WEEKLY: 3,
  MONTHLY: 4,
  QUARTERLY: 5
};
export const PERIOD_OPTIONS = [
  { value: PERIOD.DAILY30, label: "dashboard.period.daily30" },
  { value: PERIOD.DAILY7, label: "dashboard.period.daily7" },
  { value: PERIOD.WEEKLY, label: "dashboard.period.weekly" },
  { value: PERIOD.MONTHLY, label: "dashboard.period.monthly" },
  {
    value: PERIOD.QUARTERLY,
    label: "dashboard.period.quarterly"
  }
];
export const PERIOD_CHART_TIME_LABEL_UNIT = {
  [PERIOD.DAILY30]: "day",
  [PERIOD.DAILY7]: "day",
  [PERIOD.WEEKLY]: "week",
  [PERIOD.MONTHLY]: "month",
  [PERIOD.QUARTERLY]: "quarter"
};
export const DESIGN_TYPE_COMPONENT = {
  [CHART_TYPE.NPS]: "TNps",
  [CHART_TYPE.CES]: "TGauge",
  [CHART_TYPE.CES2]: "TGauge",
  [CHART_TYPE.CSAT]: "TGauge",
  [CHART_TYPE.INTERACTIONS]: "TInteractions",
  [CHART_TYPE.COLUMN]: "TColumn",
  [CHART_TYPE.SURVEY_OPINIONS]: "TSurveyOpinions",
  [CHART_TYPE.PERFORMANCE_DATA]: "TPerformanceData",
  [CHART_TYPE.PERFORMANCE_FUNNEL]: "TPerformanceFunnel",
  [CHART_TYPE.CUSTOMER_FEELINGS]: "TCustomerFeelings",
  [CHART_TYPE.EVOLUTION]: "TLine",
  [CHART_TYPE.CESINDEX]: "TCesIndex",
  [CHART_TYPE.DISTRIBUTION]: "TDistribution",
  [CHART_TYPE.PERFORMANCE_FUNNEL_WIDGET]: "TPerformanceWidget",
  [CHART_TYPE.WORDS_CLOUD]: "TWordsCloud",
  [CHART_TYPE.CATEGORIES]: "TCategories",
  [CHART_TYPE.MULTIPLECHOICE]: "TMultipleChoice"
};

export const DESIGN_TYPE = {
  COLUMN: 5,
  LINE: 10
};

export const CHART_TYPE_COMPONENT = {
  TNps: CHART_TYPE.NPS,
  TGauge: CHART_TYPE.CES,
  TInteractions: CHART_TYPE.INTERACTIONS,
  TColumn: CHART_TYPE.COLUMN,
  TSurveyOpinions: CHART_TYPE.SURVEY_OPINIONS,
  TPerformanceData: CHART_TYPE.PERFORMANCE_DATA,
  TPerformanceFunnel: CHART_TYPE.PERFORMANCE_FUNNEL,
  TCustomerFeelings: CHART_TYPE.CUSTOMER_FEELINGS,
  TLine: CHART_TYPE.EVOLUTION,
  TCesIndex: CHART_TYPE.CESINDEX,
  TDistribution: CHART_TYPE.DISTRIBUTION,
  TPerformanceWidget: CHART_TYPE.PERFORMANCE_FUNNEL_WIDGET,
  TWordsCloud: CHART_TYPE.WORDS_CLOUD,
  TCategories: CHART_TYPE.CATEGORIES,
  TMultipleChoice: CHART_TYPE.MULTIPLECHOICE
};

export const CHARTS = {
  [CHART_TYPE.NPS]: {
    DESIGN: [CHART_TYPE.NPS],
    DEFAULT_NAME: "dashboard.charts.nps.default_title",
    MULTI_METRICS: false,
    COMPARE_SURVEYS: false,
    RESIZABLE: true,
    ALLOW_METRICS: [5, 6],
    LAYOUT: { x: 0, y: 0, w: 6, h: 20, minW: 6, minH: 20, maxH: 20 },
    SIZES: [6, 9, 12]
  },
  [CHART_TYPE.CES]: {
    DESIGN: [CHART_TYPE.CES],
    DEFAULT_NAME: "dashboard.charts.ces.default_title",
    MULTI_METRICS: true,
    COMPARE_SURVEYS: false,
    ALLOW_METRICS: [1],
    RESIZABLE: false,
    LAYOUT: { x: 0, y: 0, w: 3, h: 32 }
  },
  [CHART_TYPE.CES2]: {
    DESIGN: [CHART_TYPE.CES2],
    DEFAULT_NAME: "dashboard.charts.ces2.default_title",
    MULTI_METRICS: true,
    COMPARE_SURVEYS: false,
    ALLOW_METRICS: [12],
    RESIZABLE: false,
    LAYOUT: { x: 0, y: 0, w: 3, h: 32 }
  },
  [CHART_TYPE.CESINDEX]: {
    DESIGN: [CHART_TYPE.CESINDEX],
    DEFAULT_NAME: "dashboard.charts.index.default_title",
    MULTI_METRICS: false,
    COMPARE_SURVEYS: false,
    ALLOW_METRICS: [12],
    RESIZABLE: true,
    LAYOUT: { x: 0, y: 0, w: 6, h: 20, minW: 6, minH: 20, maxH: 20 },
    SIZES: [6, 9, 12]
  },
  [CHART_TYPE.CSAT]: {
    DESIGN: [3],
    DEFAULT_NAME: "dashboard.charts.csat.default_title",
    MULTI_METRICS: true,
    COMPARE_SURVEYS: false,
    ALLOW_METRICS: [2],
    RESIZABLE: false,
    LAYOUT: { x: 0, y: 0, w: 3, h: 32 }
  },
  [CHART_TYPE.INTERACTIONS]: {
    DESIGN: [4],
    DEFAULT_NAME: "dashboard.charts.interactions.default_title",
    MULTI_METRICS: true,
    RESIZABLE: true,
    COMPARE_SURVEYS: false,
    LAYOUT: {
      x: 0,
      y: 0,
      w: 6,
      h: 40,
      minW: 6,
      minH: 32
    },
    SIZES: [6, 9, 12]
  },
  [CHART_TYPE.COLUMN]: {
    DESIGN: [5],
    DEFAULT_NAME: "dashboard.charts.column.default_title",
    MULTI_METRICS: true,
    RESIZABLE: true,
    COMPARE_SURVEYS: true,
    LAYOUT: {
      x: 0,
      y: 0,
      h: 31,
      w: 6,
      minH: 32,
      minW: 6
    },
    SIZES: [6, 9, 12]
  },
  [CHART_TYPE.SURVEY_OPINIONS]: {
    DESIGN: [6],
    DEFAULT_NAME: "dashboard.charts.survey_opinions.default_title",
    MULTI_METRICS: true,
    RESIZABLE: true,
    COMPARE_SURVEYS: false,
    LAYOUT: {
      x: 0,
      y: 0,
      h: 38,
      w: 6,
      minH: 38,
      minW: 6,
      SIZES: [6, 9, 12]
    }
  },
  [CHART_TYPE.PERFORMANCE_DATA]: {
    DESIGN: [7],
    DEFAULT_NAME: "dashboard.charts.performance_data.default_title",
    MULTI_METRICS: true,
    RESIZABLE: false,
    COMPARE_SURVEYS: false,
    LAYOUT: {
      x: 0,
      y: 0,
      h: 32,
      w: 3
    }
  },
  [CHART_TYPE.PERFORMANCE_FUNNEL]: {
    DESIGN: [8],
    DEFAULT_NAME: "dashboard.charts.performance_funnel.default_title",
    MULTI_METRICS: true,
    RESIZABLE: false,
    COMPARE_SURVEYS: false,
    LAYOUT: {
      x: 0,
      y: 0,
      h: 32,
      w: 3
    }
  },
  [CHART_TYPE.CUSTOMER_FEELINGS]: {
    DESIGN: [9],
    DEFAULT_NAME: "dashboard.charts.customer_feelings.default_title",
    MULTI_METRICS: true,
    COMPARE_SURVEYS: false,
    RESIZABLE: true,
    ALLOW_METRICS: [5, 6, 1, 2, 12],
    LAYOUT: {
      x: 0,
      y: 0,
      w: 6,
      h: 20,
      minW: 6,
      minH: 20,
      maxH: 20
    },
    SIZES: [6, 9, 12]
  },
  [CHART_TYPE.EVOLUTION]: {
    DESIGN: [DESIGN_TYPE.COLUMN, DESIGN_TYPE.LINE],
    DEFAULT_NAME: "dashboard.charts.evolution.default_title",
    MULTI_METRICS: false,
    ALLOW_METRICS: [1, 2, 5, 6, 12],
    COMPARE_SURVEYS: true,
    RESIZABLE: true,
    LAYOUT: {
      x: 0,
      y: 0,
      w: 6,
      h: 40,
      minW: 6,
      minH: 32
    },
    SIZES: [6, 9, 12]
  },
  [CHART_TYPE.DISTRIBUTION]: {
    DESIGN: [CHART_TYPE.DISTRIBUTION],
    DEFAULT_NAME: "dashboard.charts.distribution.default_title",
    MULTI_METRICS: false,
    ALLOW_METRICS: [5, 6],
    COMPARE_SURVEYS: true,
    RESIZABLE: true,
    LAYOUT: {
      x: 0,
      y: 0,
      w: 9,
      h: 40,
      minW: 9,
      minH: 32
    },
    SIZES: [9, 12]
  },
  [CHART_TYPE.PERFORMANCE_FUNNEL_WIDGET]: {
    DESIGN: [CHART_TYPE.PERFORMANCE_FUNNEL_WIDGET],
    DEFAULT_NAME: "dashboard.charts.performance_funnel.default_title",
    MULTI_METRICS: true,
    RESIZABLE: false,
    LAYOUT: {
      x: 0,
      y: 0,
      h: 48,
      w: 3,
      minH: 48
    }
  },
  [CHART_TYPE.WORDS_CLOUD]: {
    DESIGN: [CHART_TYPE.WORDS_CLOUD],
    DEFAULT_NAME: "dashboard.charts.words_cloud.default_title",
    MULTI_METRICS: false,
    ALLOW_METRICS: [1, 2, 5, 6, 9, 12],
    COMPARE_SURVEYS: false,
    RESIZABLE: true,
    LAYOUT: {
      x: 0,
      y: 0,
      w: 6,
      h: 46,
      minW: 6,
      minH: 46,
      maxH: 46
    },
    SIZES: [6, 9, 12]
  },
  [CHART_TYPE.CATEGORIES]: {
    DESIGN: [CHART_TYPE.CATEGORIES],
    DEFAULT_NAME: "dashboard.charts.categories.default_title",
    MULTI_METRICS: false,
    ALLOW_METRICS: [9],
    COMPARE_SURVEYS: false,
    RESIZABLE: true,
    LAYOUT: {
      x: 0,
      y: 0,
      h: 32,
      w: 3
    },
    SIZES: [6, 9, 12]
  },
  [CHART_TYPE.MULTIPLECHOICE]: {
    DESIGN: [CHART_TYPE.MULTIPLECHOICE],
    DEFAULT_NAME: "dashboard.charts.multiple_choice.title",
    MULTI_METRICS: false,
    ALLOW_METRICS: [4], //filter to change on back end
    COMPARE_SURVEYS: false,
    RESIZABLE: false,
    LAYOUT: {
      x: 0,
      y: 0,
      h: 64,
      w: 6,
      minH: 64,
      maxH: 64
    },
  }
};
